const getServerConfig = () => {
    const baseUrl = window.location.hostname.endsWith('spotify.net')
        ? 'https://accounts.spotify.net'
        : 'https://accounts.spotify.com';
    return {
        issuer: baseUrl,
        authorizationEndpoint: `${baseUrl}/experimental/authorize`,
        tokenEndpoint: `${baseUrl}/api/token`,
    };
};
export default getServerConfig;
//# sourceMappingURL=getServerConfig.js.map